<template>
  <v-container class="media" grid-list-xl text-xs-center>
    <v-layout row wrap justify-center>
      <div class="media__item" v-for="name in names" :key="name">
        <v-img :class="isSP ? 'media__item__img--sp' : 'media__item__img--pc'"
               :src="require('@/assets/img/' + name + '.jpeg')" contain />
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      // メディア名
      names: [
        'nhk',
        'tos',
        '大分合同新聞',
        'oab',
        'obs'
      ]
    }
  },
  computed: {
    /**
     * @return {Boolean} SPかどうか
     */
    isSP () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';
@import '@/assets/sass/color.scss';

.media {
  width: 100vw;
  &__item {
    display: flex;
    &__img {
      &--sp {
        @extend .media__item__img;
        width: 80px;
        height: 40px;
        margin: 10px 15px;
      }
      &--pc {
        @extend .media__item__img;
        width: 160px;
        height: 80px;
        margin: 0 30px;
      }
    }
  }
}
</style>
